import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  MdOutlineDashboard,
  MdAccountTree,
} from "react-icons/md";
import { FaUserGraduate, FaSignOutAlt, FaClipboardList, FaCamera, FaBookOpen, FaBoxes } from "react-icons/fa";
import logo from "../Assets/dbskills-logo.png";
import { logClientAction } from "../Api/logApi";
import toast from "react-hot-toast";

const menuGroups = [
  {
    title: "OVERVIEW",
    items: [
      {
        name: "Dashboard",
        href: "/dash",
        icon: <MdOutlineDashboard />,
        roles: ["admin", "branchUser", "superAdmin"],
      }
    ]
  },
  {
    title: "WORKSPACE",
    items: [
      {
        name: "Candidates",
        href: "/candidates",
        icon: <FaUserGraduate />,
        roles: ["admin", "branchUser", "superAdmin"],
      },
      {
        name: "Projects",
        href: "/project",
        icon: <FaBookOpen />,
        roles: ["superAdmin"],
      },
      // {
      //   name: "Programs",
      //   href: "/dash",
      //   icon: <FaBookOpen />,
      //   roles: ["admin", "superAdmin"],
      //   isAction: "programs"
      // },
      {
        name: "Centers",
        href: "/branches",
        icon: <MdAccountTree />,
        roles: ["admin", "superAdmin"],
      },
      {
        name: "Assets",
        href: "/assets",
        icon: <FaBoxes />,
        roles: ["superAdmin", "admin", "branchUser"],
      }
    ]
  },
  {
    title: "OPERATIONS",
    items: [
      {
        name: "Attendance",
        href: "/face-verify",
        icon: <FaCamera />,
        roles: ["branchUser"],
      },
      {
        name: " Scan Aadhaar & DL",
        href: "/scan-aadhar-dl",
        icon: <FaCamera />,
        roles: ["admin", "branchUser", "superAdmin"],
      },
      {
        name: "Daily Activity",
        href: "/daily-activity",
        icon: <FaClipboardList />,
        roles: ["superAdmin", "admin"],
      }
    ]
  },
  // {
  //   title: "MANAGEMENT",
  //   items: [
  //     {
  //       name: "Users",
  //       href: "/branches",
  //       icon: <FaUserGraduate />,
  //       roles: ["admin", "superAdmin"],
  //     },
  //     {
  //       name: "Reports",
  //       href: "/daily-activity",
  //       icon: <FaClipboardList />,
  //       roles: ["admin", "superAdmin"],
  //     },
  //     {
  //       name: "Settings",
  //       href: "#",
  //       icon: <FaClipboardList />,
  //       roles: ["admin", "branchUser", "superAdmin"],
  //       isSettings: true
  //     }
  //   ]
  // }
];

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const role = localStorage.getItem("role");
  const [activeButton, setActiveButton] = useState(
    localStorage.getItem("activeButton") || "Dashboard"
  );

  const filteredGroups = menuGroups.map(group => ({
    ...group,
    items: group.items.filter(item => item.roles.includes(role))
  })).filter(group => group.items.length > 0);

  const roleLabel =
    role === "superAdmin" ? "Super Admin" : role === "admin" ? "Admin" : role === "branchUser" ? "Center Staff" : "Guest";

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setIsSidebarOpen]);

  const handleLogout = () => {
    logClientAction("LOGOUT", "Auth")
      .catch((err) => console.error("Logout log error:", err))
      .finally(() => {
        localStorage.clear();
        navigate("/login");
      });
  };

  useEffect(() => {
    const currentPath = location.pathname;
    let foundName = "";
    menuGroups.forEach(g => {
      const match = g.items.find(i => i.href === currentPath);
      if (match) foundName = match.name;
    });
    if (foundName) {
      setActiveButton(foundName);
      localStorage.setItem("activeButton", foundName);
    }
  }, [location.pathname]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@500;600;700&family=Inter:wght@400;500;600;700&display=swap');

        .sidebar-wrap {
          --ink: #101826;
          --ink-line: rgba(16,24,38,0.1);
          --paper: #FFFFFF;
          --muted: #64748B;
          --teal: #2BB5CE;
          --teal-soft: #E6F7FA;
          --rose: #B23A48;
          --rose-soft: #F6DEDF;
          background: #FFFFFF;
          border-right: 1px solid var(--ink-line);
          font-family: 'Inter', sans-serif;
          color: var(--ink);
          display: flex;
          flex-direction: column;
        }

        .sb-logo-row {
          padding: 18px 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #FFFFFF;
          border-bottom: 1px solid var(--ink-line);
        }

        .sb-logo-row img {
          width: 124px;
          height: auto;
          filter: none;
          object-fit: contain;
        }

        .sb-eyebrow-rule {
          margin: 16px 20px 12px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .sb-eyebrow {
          font-family: 'IBM Plex Mono', monospace;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: var(--muted);
        }

        .sb-eyebrow-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: var(--teal);
          box-shadow: 0 0 0 3px var(--teal-soft);
        }

        .sb-nav-list {
          flex: 1;
          overflow-y: auto;
          padding: 0 12px;
        }

        .sb-item-row {
          display: flex;
          align-items: stretch;
          gap: 10px;
          width: 100%;
          border: 1px solid transparent;
          background: transparent;
          cursor: pointer;
          padding: 0;
          margin-bottom: 4px;
          border-radius: 8px;
          position: relative;
          font-family: 'Inter', sans-serif;
          text-align: left;
          transition: all 0.18s ease;
        }

        .sb-item-row.inactive {
          color: #64748B;
        }

        .sb-item-row.inactive:hover {
          background: var(--teal-soft);
          border-color: rgba(43, 181, 206, 0.2);
        }

        .sb-item-row.active-item {
          background: var(--teal-soft);
          border-color: var(--teal);
          box-shadow: 0 2px 8px rgba(43, 181, 206, 0.15);
        }

        .sb-dot-badge {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #CBD5E1;
          margin-left: 14px;
          margin-right: 2px;
          flex-shrink: 0;
          align-self: center;
          transition: all 0.18s ease;
        }

        .sb-item-row.active-item .sb-dot-badge {
          background: var(--teal);
          box-shadow: 0 0 0 3px var(--teal-soft);
        }

        .sb-item-row.inactive:hover .sb-dot-badge {
          background: var(--teal);
        }

        .sb-item-main {
          flex: 1;
          display: flex;
          align-items: center;
          gap: 11px;
          padding: 9px 14px 9px 2px;
          min-width: 0;
        }

        .sb-icon {
          font-size: 16px;
          flex-shrink: 0;
          color: var(--muted);
          display: flex;
          align-items: center;
          transition: color 0.18s ease;
        }

        .sb-item-row.active-item .sb-icon {
          color: var(--teal);
        }

        .sb-item-row.inactive:hover .sb-icon {
          color: var(--teal);
        }

        .sb-label {
          font-size: 13px;
          font-weight: 500;
          color: var(--muted);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          transition: color 0.18s ease;
        }

        .sb-item-row.active-item .sb-label {
          color: var(--ink);
          font-weight: 700;
        }

        .sb-item-row.inactive:hover .sb-label {
          color: var(--teal);
        }

        .sb-spine {
          position: absolute;
          left: -12px;
          top: 8px;
          bottom: 8px;
          width: 3px;
          border-radius: 2px;
          background: var(--teal);
          transform: scaleY(0);
          transform-origin: center;
          transition: transform 0.22s ease;
        }

        .sb-item-row.active-item .sb-spine {
          transform: scaleY(1);
        }

        .sb-footer {
          padding: 14px 20px 20px 20px;
          border-top: 1px solid var(--ink-line);
        }

        .sb-role-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 9px 12px;
          border-radius: 8px;
          background: #F8FAFC;
          border: 1px solid var(--ink-line);
          margin-bottom: 10px;
        }

        .sb-role-text {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;
        }

        .sb-role-label {
          font-family: 'IBM Plex Mono', monospace;
          font-size: 9px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: var(--muted);
        }

        .sb-role-value {
          font-size: 12.5px;
          font-weight: 700;
          color: var(--ink);
        }

        .sb-role-pulse {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: var(--teal);
          flex-shrink: 0;
          box-shadow: 0 0 0 3px var(--teal-soft);
        }

        .logout-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          width: 100%;
          padding: 10px 12px;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 600;
          border: 1px solid var(--ink-line);
          cursor: pointer;
          background: #FFFFFF;
          color: var(--muted);
          transition: all 0.18s ease;
          font-family: 'Inter', sans-serif;
        }

        .logout-btn:hover {
          background: var(--rose-soft);
          border-color: var(--rose);
          color: var(--rose);
        }

        .nav-stagger li { animation: navIn 0.32s ease both; }
        .nav-stagger li:nth-child(1) { animation-delay: 0.03s; }
        .nav-stagger li:nth-child(2) { animation-delay: 0.06s; }
        .nav-stagger li:nth-child(3) { animation-delay: 0.09s; }
        .nav-stagger li:nth-child(4) { animation-delay: 0.12s; }
        .nav-stagger li:nth-child(5) { animation-delay: 0.15s; }
        .nav-stagger li:nth-child(6) { animation-delay: 0.18s; }
        .nav-stagger li:nth-child(7) { animation-delay: 0.21s; }
        .nav-stagger li:nth-child(8) { animation-delay: 0.24s; }

        @keyframes navIn {
          from { opacity: 0; transform: translateX(-8px); }
          to   { opacity: 1; transform: translateX(0); }
        }

        .sidebar-wrap ::-webkit-scrollbar { width: 6px; }
        .sidebar-wrap ::-webkit-scrollbar-thumb { background: rgba(231,236,243,0.12); border-radius: 3px; }
      `}
      </style>

      <div
        className={`sidebar-wrap fixed top-0 left-0 z-50 h-screen w-64
          transition-transform duration-300
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`}
      >
        {/* Logo */}
        <div className="sb-logo-row">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        {/* Nav Items */}
        <div className="sb-nav-list flex-1 overflow-y-auto px-3 py-4">
          {filteredGroups.map((group) => (
            <div key={group.title} className="mb-6">
              <div className="px-4 mb-2 text-[10px] font-bold tracking-wider text-gray-400 uppercase">
                {group.title}
              </div>
              <ul className="space-y-1">
                {group.items.map((item) => {
                  const isActive = activeButton === item.name;
                  return (
                    <li key={item.name} className="relative">
                      <button
                        className={`sb-item-row ${isActive ? "active-item" : "inactive"}`}
                        onClick={() => {
                          if (item.isSettings) {
                            toast("Settings page is under construction");
                            return;
                          }
                          if (item.isAction === "programs") {
                            localStorage.setItem("activeButton", "Dashboard");
                            setActiveButton("Dashboard");
                            navigate("/dash", { state: { openPrograms: true } });
                            return;
                          }
                          setActiveButton(item.name);
                          localStorage.setItem("activeButton", item.name);
                          setIsSidebarOpen(false);
                          navigate(item.href);
                        }}
                      >
                        <span className="sb-spine" />
                        <span className="sb-dot-badge" />
                        <span className="sb-item-main">
                          <span className="sb-icon">{item.icon}</span>
                          <span className="sb-label">{item.name}</span>
                        </span>
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="sb-footer">
          <div className="sb-role-card">
            <div className="sb-role-text">
              <span className="sb-role-label">Signed in as</span>
              <span className="sb-role-value">{roleLabel}</span>
            </div>
            <span className="sb-role-pulse" />
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            <FaSignOutAlt style={{ fontSize: 15, flexShrink: 0 }} />
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div
          onClick={() => setIsSidebarOpen(false)}
          className="fixed inset-0 z-10 bg-black bg-opacity-40 lg:hidden"
        />
      )}
    </>
  );
};

export default Sidebar;